export default __webpack_public_path__ + "static/media/m.19d09a44.jpg";